import Ky, { NormalizedOptions } from 'ky';

/**
 * Abstract (base) class for all Service implementations.
 */
export class AbstractService<T extends Models.Base = Models.Base> {
    api: typeof Ky;

    version: string;

    constructor(serviceConfig: App.ServiceConfig) {
        this.api = Ky.create({
            ...serviceConfig,
            hooks: {
                ...serviceConfig.hooks,
                afterResponse: [this.withIdHook.bind(this)],
            },
        });

        this.version = serviceConfig.version;
    }

    // eslint-disable-next-line class-methods-use-this
    protected customizeResult(result: T): T & { id: string } {
        return result;
    }

    private async withIdHook(req: Request, opts: NormalizedOptions, res: Response): Promise<Response> {
        if (res.ok && res.status !== 204 && !req.url.includes('testRun/export') && !req.url.includes('testRun/compare')) {
            const json = await res.json();

            if ('href' in json) {
                const newJson = this.customizeResult(json);

                return new Response(JSON.stringify(newJson), {
                    status: res.status,
                    statusText: res.statusText,
                    headers: res.headers,
                });
            }

            if ('results' in json) {
                if (typeof json.results === 'object' && 'content' in json.results) {
                    // Handle nested content structure
                    json.results.content = json.results.content.map((result: T) => this.customizeResult(result));
                } else {
                    // Handle flat results array
                    json.results = json.results.map((result: T) => this.customizeResult(result));
                }

                return new Response(JSON.stringify(json), {
                    status: res.status,
                    statusText: res.statusText,
                    headers: res.headers,
                });
            }

            if (Array.isArray(json)) {
                const newJson = json.map(this.customizeResult);

                return new Response(JSON.stringify(newJson), {
                    status: res.status,
                    statusText: res.statusText,
                    headers: res.headers,
                });
            }

            return new Response(JSON.stringify(this.customizeResult(json)), {
                status: res.status,
                statusText: res.statusText,
                headers: res.headers,
            });
        }

        return res;
    }
}
